<template>
  <div>
    <div >
      <navbar/>
      <label class="title is-3">Positionnez votre club {{club.name}}</label>
      <label>
        <gmap-autocomplete
          class="input is-rounded is-info"
          @place_changed="setPlace">
        </gmap-autocomplete>
        <div style="padding-top:5px">
        <s-button @onclick="addMarker" icon="map-marker" label="Localiser" theme="is-primary"/>
        <div style="float:right">    
            <s-button icon="save" label="Enregistrer" theme="is-success" @onclick="save"/>
        </div>
        </div>
      </label>
      

    </div><br/>
    
    <gmap-map
      :center="center"
      :zoom="zoom"
      style="width:100%;  height: 400px;" 
      
    >
      <gmap-marker
        key="position"
        :position="position"
        @click="setPosition"
        :draggable="true"
         @drag="updateCoordinates" 
      ></gmap-marker>
    </gmap-map>
    <div class="notification is-warning">
    Si vous n'avez pas d'adresse exacte, vous pouvez déplacer le curseur pour le positionner exactement là où se trouve votre club
    </div>
  </div>
</template>

<script>
export default {
  name: "GoogleMap",
  props:["club"],
  data() {
    return {
      // default to montreal to keep it simple
      // change this to whatever makes sense
      center: { lat: 47, lng: 3 },
      position: {},
      places: [],
      currentPlace: null,
      zoom: 5
    };
  },

  mounted() {
    this.geolocate();
  },
  
  methods: {
    save() {

    },
      //center=m.position
    setPosition(e) {
        console.log(e)
    },
     updateCoordinates(location) {
            console.log(location.latLng.lat());
            console.log(location.latLng.lng());
               
        },
    setPlace(place) {
      this.currentPlace = place;
    },
    mark(event) {
               console.log(event)
             
    },
    addMarker() {
      if (this.currentPlace) {
        this.position = {
          lat: this.currentPlace.geometry.location.lat(),
          lng: this.currentPlace.geometry.location.lng()
        };
        this.center = this.position;
      
      }
    },
    geolocate: function() {
      navigator.geolocation.getCurrentPosition(position => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
      });
    }
  }
};
</script>
